
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, AppState } from "../../store/configureStore";
import { setIsSidebarOpen } from "../../store/slices/sidebar";

interface Props {
    className?: string;
}
const Hamburger: React.FC<Props> = ({ className = "" }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { sidebarIsOpen } = useSelector((state: AppState) => state.entities.sidebar);

    const toggleSidebar = (event: React.MouseEvent) => {
        event.stopPropagation();
        dispatch(setIsSidebarOpen(!sidebarIsOpen));
    };

    return (
        <div className={`s_hamburger ${className}`} onClick={toggleSidebar} >
            <FontAwesomeIcon icon={faBars} />
        </div >
    );
};

// Wrap with React.memo for performance
export default React.memo(Hamburger);